<template>
  <div class="pricing-container-v3">
    <link rel="stylesheet" :href="`${presenterDomain}/pricing.css`">
    <div @click="scrollToPlanUpgradePlan">
      <BannerSuccess

        v-if="isValidPromoCode"
        class="mb-3 cursor-pointer"
      >
        {{ $i18nPresenter.t('Your promotion is ready! Select a plan below to apply your discount at checkout.') }}
      </BannerSuccess>
    </div>

    <div class="pricing-container" :class="{'pricing-container-mobile': fromMobile}">
      <div id="pricing-compare">
        <div
          v-if="$store.state.plan && $store.state.plan.type !== 'pro-yearly' &&
            $store.state.plan.group !== 'white-label'"
        >
          <div class="pricing-plan-edu" v-if="isShowBackToNonEdu">
            <span class="back-non-edu-plan">
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.219738 6.59278C-0.073245 6.2648 -0.073245 5.73218 0.219738 5.40421L3.21988 2.04578C3.51287
                1.71781 3.98867 1.71781 4.28165 2.04578C4.57464 2.37375 4.57464 2.90638 4.28165 3.23435L2.56126
                5.1602L11.25 5.1602C11.6648 5.1602 12 5.5354 12 5.9998C12 6.46421 11.6648 6.83941 11.25 6.83941L2.56126
                6.83941L4.28165 8.76526C4.57464 9.09323 4.57464 9.62585 4.28165 9.95383C3.98867 10.2818 3.51287 10.2818
                3.21988 9.95383L0.219738 6.5954V6.59278Z"
                  fill="#348EF6"
                />
              </svg>
              <a class="primary" href="javascript:void(0);" @click="backToNonEducational">
                {{ $i18nPresenter.t('Back to standard plans') }}
              </a>
            </span>
            <div class="pricing-toggle-title">
              {{ $i18nPresenter.t('Educational Plans') }}
            </div>
            <div class="pricing-decs-edu">
              {{ $i18nPresenter.t('Special pricing for teachers, students, and nonprofit organisations.') }}
            </div>
          </div>

          <div v-else :class="{'show-edu-plan': isShowBackToNonEdu}" class="pricing-desktop ">
            <div class="pricing-toggle-wrapper">
              <div :class="{'font-bold-v2': !isAnnual}" class="aha__save">
                {{ $i18nPresenter.t('Monthly') }}
              </div>
              <toggle-button
                :sync="true"
                :value="isAnnual"
                :width="45"
                :height="28"
                class="mb-0"
                :color="{
                  checked: '#348EF6',
                  unchecked: '#D3D7E1'
                }"
                @change="toggleButtonSwitch()"
              />
              <div class="user-pricing-yearly" :class="{'font-bold-v2': isAnnual}">
                {{ $i18nPresenter.t('Yearly') }}
                <div class="pricing-label-discount">
                  <p>{{ $i18nPresenter.t('Save 67%') }}</p>
                </div>
              </div>
            </div>
          </div>
          <!--      add css taiwind mobile show up -->
          <div class="pricing-desktop ">
            <PricingDesktop
              :planName="planName"
              :toggleButtonSwitch="toggleButtonSwitch"
              @learnMore="learnMore"
              :permission="permission"
              @upgradePlan="upgradePlan"
              :isShowBackToNonEdu="isShowBackToNonEdu"
            />

            <div class="title-open-edu" v-if="isShowTitleOpenEdu">
              <span>
                <b>{{ $i18nPresenter.t('Educational plans') }}</b>
              </span> —  {{ $i18nPresenter.t('Special rates for teachers, students and nonprofit organisations.') }}
              <a class="primary" href="#upgrade-your-plan" @click="openEducation()">
                {{ $i18nPresenter.t('Learn more') + ' ' }}
              </a>
              <svg
                width="12"
                height="10"
                viewBox="0 0 12 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
              >
                <path
                  d="M11.7803 5.59278C12.0732 5.2648 12.0732 4.73218 11.7803 4.40421L8.78012
                1.04578C8.48713 0.717812 8.01133 0.717812 7.71835 1.04578C7.42536 1.37375 7.42536
                1.90638 7.71835 2.23435L9.43874 4.1602L0.750037 4.1602C0.335173 4.1602 0 4.5354 0 4.9998C0
                5.46421 0.335173 5.83941 0.750037 5.83941L9.43874 5.83941L7.71835 7.76526C7.42536 8.09323
                7.42536 8.62585 7.71835 8.95383C8.01133 9.2818 8.48713 9.2818 8.78012 8.95383L11.7803 5.5954V5.59278Z"
                  fill="#348EF6"
                />
              </svg>
            </div>
          </div>
        </div>
        <BulkPricing v-if="canShowBulkPricingSection" />
        <ComparePlansSection
          :billingCycle="planName"
          :togglePlan="_togglePlan"
          :permission="permission"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Config from '@/config'
import Utils from '@/util'
import PricingDesktop from './PricingDesktop.vue'
import ComparePlansSection from './ComparePlansSection.vue'

import eventCategories from '@/constant/eventCategories'
import EventBus from '@/eventBus'
import BulkPricing from '@/components-v2/my-plan/user-pricing-v3/BulkPricing.vue'
import BannerSuccess from '@/components-v2/my-plan/BannerSuccess.vue'

const PLAN_GROUPS = ['annual', 'one-time', 'educational', 'monthly']
export default {
  name: 'UserPricing',
  components: {
    BannerSuccess,
    BulkPricing,
    ComparePlansSection,
    PricingDesktop,
  },
  props: {
    permission: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      hiddenPlanEdu: true,
      showTitleOpenEdu: true,
      planName: 'annual',
      planColour: '',
      showDetails: false,
      domain: '',
      fromMobile: false,
      presenterDomain: Config.presenterDomain,
    }
  },
  computed: {
    ...mapGetters([
      'currentUserIsTeamOwnerOrAdmin',
      'isTeamCreatedByCustomerSuccess',
    ]),
    ...mapState({
      currentUser: (state) => state.currentUser,
      currentAccount: (state) => state.currentAccount,
      isValidPromoCode: (state) => state.isValidPromoCode,
    }),
    isShowBackToNonEdu() {
      return !this.showTitleOpenEdu && this.abTestOpenEdu
    },
    isAnnual() {
      return this.planName == 'annual'
    },
    isShowTitleOpenEdu() {
      return this.showTitleOpenEdu && this.abTestOpenEdu
    },
    isHiddenSwitchPlanEdu() {
      return this.hiddenPlanEdu && this.abTestOpenEdu
    },
    abTestOpenEdu() {
      return true
    },
    canShowBulkPricingSection() {
      if (!this.currentAccount || !this.currentAccount.id) return true
      return this.currentUserIsTeamOwnerOrAdmin &&
          !this.isTeamCreatedByCustomerSuccess &&
          (this.currentAccount.plan == 'free' || this.currentAccount.plan == null) &&
          this.planName !== 'educational'
    },
  },
  mounted() {
    this.domain = Config.domain
    if (PLAN_GROUPS.includes(Utils.getParamValue('planGroup'))) {
      this.planName = Utils.getParamValue('planGroup')
    }

    EventBus.$on('clickShowEduPlan', () => {
      this.openEducation(true)
    })
  },
  destroyed() {
    EventBus.$off('clickShowEduPlan')
  },
  methods: {
    toggleButtonSwitch() {
      if (this.planName === 'annual') {
        this._togglePlan('monthly')
      } else {
        this._togglePlan('annual')
      }
    },
    scrollToPlanUpgradePlan() {
      const pricingCompareDom = document.getElementById('upgrade-your-plan')
      pricingCompareDom.scrollIntoView({ behavior: 'smooth' })
    },
    isProPlan() {
      return this.$store.state.plan.group == 'pro'
    },
    isWhiteLabel() {
      return this.$store.state.plan.group === 'white-label'
    },
    openEducation(fromMobile = false) {
      Utils.mixpanelTracking('My plan', 'Show Plan Edu')
      this.fromMobile = fromMobile
      this._togglePlan('educational')
    },
    backToNonEducational() {
      Utils.mixpanelTracking('My plan', 'Show Non-Edu Plans')
      this.showTitleOpenEdu = true
      this.$emit('back-to-non-edu', true)
      this._togglePlan('annual')
    },
    learnMore(plan) {
      Utils.mixpanelTracking(eventCategories.MY_PLAN, 'Learn more', plan)
      const element = document.getElementById('sticky-wrapper')
      const top = element.offsetTop - 50
      window.scrollTo(0, top)
    },
    upgradePlan(planType) {
      Utils.mixpanelTracking('My plan > Upgrade > Top', 'Upgrade', planType)
      setTimeout(() => {
        window.location.href = `${Config.presenterDomain}/apps/upgrade/${planType}`
      }, 500)
    },
    togglePlanEduByPlan(plan) {
      if (plan !== 'educational') {
        this.showTitleOpenEdu = true
        this.hiddenPlanEdu = true
      } else {
        this.showTitleOpenEdu = false
      }
    },

    _togglePlan(plan) {
      if (!plan) return
      this.togglePlanEduByPlan(plan)
      this.planName = plan
      Utils.mixpanelTracking(
        eventCategories.MY_PLAN,
        'Change Plan Tab',
        plan,
      )
    },
    _showMobileDetailsPlan(planColour, planName) {
      const showDetails = this.$refs[`show-${planColour}${planName}`]
      const hideDetails = this.$refs[`hide-${planColour}${planName}`]
      const details = this.$refs[`details-${planColour}${planName}`]
      showDetails.classList.remove('active')
      hideDetails.classList.add('active')
      details.classList.add('active')
      this.planColour = planColour
      this.planName = planName
    },
    _hideMobileDetailsPlan(planColour, planName) {
      const showDetails = this.$refs[`show-${planColour}${planName}`]
      const hideDetails = this.$refs[`hide-${planColour}${planName}`]
      const details = this.$refs[`details-${planColour}${planName}`]
      showDetails.classList.add('active')
      hideDetails.classList.remove('active')
      details.classList.remove('active')
    },
  },
}
</script>

<style lang="scss" module>
</style>
